import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFileText: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"file-text, document"} maskId="square-filled-radius-0-stroke-1-IconFileText"><path fillRule="evenodd" clipRule="evenodd" d="M12.5 9.5H20V22H4V2H12.5V9.5ZM8 18H16V17H8V18ZM8 14H13V13H8V14Z" fill="currentColor"/><path d="M19.707 8.5H13.5V2.29297L19.707 8.5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconFileText;
